import { lazy } from 'react';
import type { ComponentType } from 'react';

const RELOAD_KEY = 'frk-external-portal:chunk-reload-attempted';

const isChunkLoadError = (error: unknown): boolean => {
  const name = error instanceof Error ? error.name : '';
  const message = error instanceof Error ? error.message : String(error ?? '');
  return (
    name === 'ChunkLoadError' ||
    /Loading chunk \d+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message)
  );
};

const hasBrowserStorage = (): boolean =>
  typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined';

export const lazyWithRetry = <T extends ComponentType<any>>(
  importer: () => Promise<{ default: T }>
) =>
  lazy(() =>
    importer()
      .then((module) => {
        if (hasBrowserStorage()) {
          window.sessionStorage.removeItem(RELOAD_KEY);
        }
        return module;
      })
      .catch((error) => {
        if (isChunkLoadError(error) && hasBrowserStorage()) {
          const alreadyReloaded = window.sessionStorage.getItem(RELOAD_KEY) === '1';
          if (!alreadyReloaded) {
            window.sessionStorage.setItem(RELOAD_KEY, '1');
            window.location.reload();
            return new Promise<{ default: T }>(() => {});
          }
        }
        throw error;
      })
  );
